import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LoginBg from '../assets/pattern.png';

const useStyles = makeStyles((theme) => ({
    loginbgimg: {
        backgroundImage: `url(${LoginBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      },
      
}));

function Otp() {
    const classes = useStyles();
  return (
    <div>
        <h3>Enter Otp</h3>
        <div className='otpinput'>
            <input type='text' />
            <input type='text' />
            <input type='text' />
            <input type='text' />
        </div>

    </div>
  )
}

export default Otp